/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMonatsauswertungLayoutDto } from '../../models/create-monatsauswertung-layout-dto';
import { MonatsauswertungLayoutDto } from '../../models/monatsauswertung-layout-dto';

export interface CreateMonatsauswertungLayout$Json$Params {
      body?: CreateMonatsauswertungLayoutDto
}

export function createMonatsauswertungLayout$Json(http: HttpClient, rootUrl: string, params?: CreateMonatsauswertungLayout$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MonatsauswertungLayoutDto>> {
  const rb = new RequestBuilder(rootUrl, createMonatsauswertungLayout$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MonatsauswertungLayoutDto>;
    })
  );
}

createMonatsauswertungLayout$Json.PATH = '/v1/monatsauswertungen/layouts';
